import React from "react";
import { IOSSwitch } from "components/IOSSwitch";
import * as UIcons from '@iconscout/react-unicons';
import { useLocation, useNavigate, useParams } from 'react-router-dom'

export default function TrailerDetails({ trailer = {}, onEdit = () => null, onClose = () => null }) {
  const { state } = useLocation();
  const params = useParams()
  trailer = state?.trailer || trailer || {};
  const title = trailer?.name || trailer?.title || "This is the title of the movie";
  const description = trailer?.description || `"Avengers: Endgame" is the epic conclusion to the Marvel Cinematic Universe's Infinity Saga. Following the devastating events of "Avengers: Infinity War," where the villain Thanos wiped out half of all life in the universe with a snap of his fingers, the remaining Avengers must grapple with their loss and find a way to reverse the catastrophic effects of Thanos’s actions.`;
  const fileName = trailer?.fileName || trailer?.key || trailer?.src || "movienamegrighter.mov";
  const status = (trailer?.status || '').toLowerCase() === 'live' || (trailer?.published ?? true);
  const navigate = useNavigate()

  return (
    <div className="min-h-screen w-full flex flex-col">
      <div className="flex items-center justify-between px-6 py-4 border-b">
        <button onClick={()=>{
            onClose()
            navigate(-1)
        }} className="w-8 h-8 flex items-center justify-center rounded-md bg-gray-100">
          <UIcons.UilMultiply className="text-black" />
        </button>
        <p className="text-black font-bold">Trailer detail</p>
        <div className="flex items-center gap-2">
          <button onClick={()=>{
            onEdit()
            navigate(`/movie-box/${params?.movieId}/trailers/${params?.trailerId}/edit`)
        }} className="px-4 py-2 rounded-md bg-gray-100 text-black">Edit</button>
          <button className="w-10 h-10 flex items-center justify-center rounded-md border">
            <UIcons.UilEllipsisH className="text-black" />
          </button>
        </div>
      </div>

      <div className="w-full flex justify-center px-6 py-10">
        <div className="w-full max-w-xl bg-white rounded-xl border p-5">
          <div className="mb-4">
            <p className="text-sm font-semibold text-gray-700">Movie title</p>
            <p className="text-gray-900">{title}</p>
          </div>

          <div className="mb-4">
            <p className="text-sm font-semibold text-gray-700">Description</p>
            <p className="text-gray-900 leading-6">{description}</p>
          </div>

          <div className="mb-4">
            <p className="text-sm font-semibold text-gray-700">Media file</p>
            <p className="text-gray-900">{fileName}</p>
          </div>

          <div className="mb-2 flex items-center justify-between">
            <div>
              <p className="text-sm font-semibold text-gray-700">Status</p>
              <p className="text-gray-600">This movie is currently live and visible to users.</p>
            </div>
            <IOSSwitch checked={status} />
          </div>
        </div>
      </div>
    </div>
  );
}
